<script>
    import { Router, Route } from 'svelte-routing';
    import FirstDesign from "./FirstDesign.svelte";
    import Form from "./Form.svelte";
    import Privacy from "./Privacy.svelte";
</script>

<main>
    <Router>
        <Route path="/" component={FirstDesign} />
        <Route path="/appointment" component={Form} />
        <Route path="/privacy" component={Privacy} />
    </Router>
</main>

<style>
    :global(body) {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        height: 100%;
        width: 100dvw;
        position: fixed;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        font-family: 'Poppins',serif;
    }
    :global(html) {
        overflow: hidden;
    }

    main {
        margin: 0;
        padding: 0;
        width:100dvw;
        height: 100dvh;
        display: flex;
        justify-content: center;
    }

    @media (max-width: 768px) {
        :global(body) {
            font-size: 14px;
        }
    }
</style>
